<app-header></app-header>
<router-outlet></router-outlet>
<app-trial-footer-banner *ngIf="store.user && store.trialMode"></app-trial-footer-banner>
<app-trial-activate-modal
  *ngIf="store.trialUpgradeModal"
  [upgradeLocation]="store.trialUpgradeLocation"
></app-trial-activate-modal>
